module.exports = __webpack_public_path__ + "img/souswjg.c1056cae.png";